<template>
<div class="container pt-5 pb-5" style="margin-top: 82px;">
    <div class="page-heading mb-3">
        <h1 class="display-2 montserrat mb-0">Sign up</h1>
        <p class="text-muted mt--2 text-sm">Create your account to get started</p>
    </div>
    <div class="page-heading">
        <p class="font-weight-400">Already have an account? <a href="/">Log in</a> instead</p>
    </div>

    <h6 class="heading-small text-muted mt-3">Account Information</h6>
    <div class="row">
        <div class="col-lg-3 order-lg-2">
            <avatar-uploader cardless v-model="form.account.display_image" :size="{width:220, height:220}"></avatar-uploader>
        </div>
        <div class="col-lg-9 order-lg-1">
            <div class="row">
                <div class="col-lg-9 col-sm-12">
                    <form-input label="Email" placeholder="Email" v-model="form.account.email" :disabled="hasProviderEmail" ref="account.email" style="width: calc(100% - 190px);" class="inline-block"></form-input>
                    <template v-if="!hasEmail">
                        <button class="btn mt--1 ml-2 verification-button disabled" disabled type="button" @click="sendVerificationCode">
                                <i class="fas fa-paper-plane mr-2"></i> Send code
                        </button>
                    </template>
                    <template v-else-if="verificationIntervalCounter == 0">
                        <button class="btn mt--1 ml-2 verification-button" type="button" @click="sendVerificationCode">
                                <i class="fas fa-paper-plane mr-2"></i> Send code
                        </button>
                    </template>
                    <template v-else>
                        <button class="btn mt--1 ml-2 disabled text-dark verification-button" disabled>
                                <i class="fas fa-paper-plane mr-2"></i> Resend code ({{ verificationIntervalCounter }})
                        </button>
                    </template>

                    <div v-if="hasSentVerificationMail" class="row">
                        <div class="col-auto"><i class="fa fa-info-circle"></i></div>
                        <div class="col pl-0">
                            <span class="text-muted">Please check your email for the verification code</span>
                        </div>
                    </div>
                </div>
                <div v-if="!hasProvider" class="col-lg-6 col-sm-12">
                    <form-input label="Verification code" placeholder="Verification code" v-model="form.account.verification_code" ref="account.verification_code"></form-input>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input label="Referrer Code" show-optional-label optional-label="(Optional)" placeholder="Referrer Code" v-model="form.account.referrer_code" ref="account.referrer_code"></form-input>
                </div>
                <div v-if="!hasProvider" class="col-lg-6 col-sm-12">
                    <form-input label="Password" placeholder="Password" type="password" v-model="form.account.password" ref="account.password"></form-input>
                </div>
                <div v-if="!hasProvider" class="col-lg-6 col-sm-12">
                    <form-input label="Confirm Password" placeholder="Confirm Password" type="password" v-model="form.account.password_confirmation" ref="account.password_confirmation"></form-input>
                </div>
            </div>
        </div>
    </div>


    <h6 class="heading-small text-muted mt-3">Profile Information</h6>
    <div class="row">
        <div class="col-lg-10 col-sm-12">
            <form-input label="Last Name" placeholder="Last Name" v-model="form.account.lastname" ref="account.lastname"></form-input>
        </div>
        <div class="col-lg-6 col-sm-12">
            <form-input label="First Name" placeholder="First Name" v-model="form.account.firstname" ref="account.firstname"></form-input>
        </div>
        <div class="col-lg-4 col-sm-12">
            <form-input label="Middle Name" placeholder="Middle Name" v-model="form.account.middlename" ref="account.middlename"></form-input>
        </div>
        <div class="col-lg-6 col-sm-12">
            <form-date-picker label="Birthdate" placeholder="Birthdate" v-model="form.account.birthdate" ref="account.birthdate"></form-date-picker>
        </div>
        <div class="col-lg-4 col-sm-12">
            <form-select label="Sex" placeholder="Sex" :options='genders' v-model="form.account.gender" ref="account.gender"></form-select>
        </div>
        <div class="col-lg-4 col-sm-12">
            <form-input label="Mobile No." placeholder="13-digit mobile no" :mask="['+639#########']" v-model="form.account.mobile_no" ref="account.mobile_no"></form-input>
        </div>
    </div>

    <h6 class="heading-small text-muted mt-3">Address Information</h6>
    <div class="row">
        <div class="col-lg-6">
            <google-map></google-map>
        </div>
        <div class="col-lg-6">
            <div class="row">
                <div class="col-lg-12">
                    <form-input
                        placeholder="Unit/House no, Building, Street name"
                        label="Unit/House no, Building, Street name"
                        v-model="form.address.specification"
                        ref="address.specification"
                    ></form-input>
                </div>
                <div class="col-lg-12">
                    <form-input
                        label="Barangay"
                        placeholder="Barangay"
                        v-model="form.address.barangay"
                        ref="address.barangay"
                    >
                    </form-input>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input
                        placeholder="City/Municipality"
                        label="City/Municipality"
                        v-model="form.address.city"
                        ref="address.city"
                    ></form-input>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input
                        placeholder="Province"
                        label="Province"
                        v-model="form.address.province"
                        ref="address.province"
                    ></form-input>
                </div>
                <div class="col-lg-6">
                    <form-input
                        placeholder="Zipcode"
                        label="Zipcode"
                        v-model="form.address.zipcode"
                        ref="address.zipcode"
                    ></form-input>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-5 text-right">
        <button class="btn btn-warning" @click="save">
            <i class="fa fa-save r-2"></i> Sign up
        </button>
    </div>
</div>
</template>

<script>
import mixins from "@utils/mixins";
import Form from "@models/components/Form";
import { route, post } from "@utils/network";

export default {
name: "SignUpPage",

computed: {
    hasProvider() {
        return this.form.account.provider != "email";
    },
    hasEmail() {
        return this.form.account.email && this.form.account.email.length > 0;
    },
},

data: () => ({
    verificationIntervalCounter: 0,
    verificationInterval: null,
    hasSentVerificationMail: false,
    hasProviderEmail: false,
    genders: [
        { text: "Male", value: "male" },
        { text: "Female", value: "Female" },
    ],
    form: new Form({
        account: {
            email: null,
            verification_code: null,
            password: null,
            password_confirmation: null,
            firstname: null,
            middlename: null,
            lastname: null,
            birthdate: null,
            gender: null,
            display_image: null,
            provider: "email",
            provider_id: null,
            provider_token: null,
            referrer_code: null,
            contact_no: null,
        },
        address: {
            specification: "",
            barangay: "",
            city: "",
            province: "",
            country: "Philippines",
            zipcode: "",
            lat: "",
            lng: "",
            place_id: "",
        },
    })
}),

methods: {
    sendVerificationCode() {
        this.verificationIntervalCounter = 60;
        this.verificationInterval = setInterval(() => {
            this.verificationIntervalCounter--;

            if (this.verificationIntervalCounter <= 0) {
                clearInterval(this.verificationInterval);
            }
        }, 1000)
        this.sendVerificationMail();
    },

    sendVerificationMail() {
        const { email } = this.form.account;
        post(route('email-verifications'), { data: { email } })
            .then(response => this.hasSentVerificationMail = true)
            .catch(error =>  {
                this.verificationIntervalCounter = 1;
                this.promptErrors(error.response.data.message);
                if (error.response.data.errors.email) {
                    this.$refs["account.email"].error = error.response.data.errors.email;
                }
            });
    },

    async save() {
        event.preventDefault();
        if (!(await this.confirm("Are you sure you want to save this data?", "")).value) {
            return;
        }

        post(route('sign-up'), { data: this.form.getData() })
            .then(response => this.saved(response))
            .catch(error => this.failedToSave(error));
    },

    async saved(response) {
        const { user, token } = response.data.result;
        this.$store.dispatch("initializeAuthData", { user, token });

        await this.promptMessage(response.data.message.message, "");

        this.redirectLogin();
    },
    redirectLogin() {
        if (this.$route.query.stat === "booking-checkout") {
            this.$router.push({ name: 'Create Booking Page', query: { stat: "booking-checkout" } })
        }
        this.reload();
    },
    failedToSave(error) {
        this.promptFormErrors(this.$refs, error);
    },
    initializeProviderData(data) {
        this.form.account.email = data.email;
        this.hasProviderEmail = data.email && data.email.length > 0;
        this.form.account.firstname = data.firstname;
        this.form.account.lastname = data.lastname;
        this.form.account.provider = data.provider;
        this.form.account.provider_id = data.provider_id;
    }
},

mixins: [mixins],

mounted() {
    if (this.$route.params.provider_data) {
        this.initializeProviderData(this.$route.params.provider_data);
    }
}
}
</script>

<style lang="css" scoped>
.verification-button {
    position: absolute;
    top: 35px;
    right: 16px;
}
</style>